<template>
  <div id="zt595">
    <div id="z1">
      <div>ZT595 自助支付模块</div>
      <label>通过PCI5.0认证，安全可靠</label>
    </div>
    <div id="z2">
      <label>ZT595是高性能支付主控模块，整机通过了PCI5.0认证，用户通过金属密码键盘输入密码，完成支付交易，安全可靠。同时模块提供丰富的外部接口，用户可根据自己的需求扩展不同的功能；广泛应用于加油站、汽车充电站、停车场、新零售等自助场景。</label>
    </div>
    <div id="z3">
      <div>搭配灵活  易于扩展</div>
      <label>可扩展读卡器、身份识别模块、指纹识别模块及支付模块</label>
    </div>
    <div id="z4">
      <div>坚固可靠  经久耐用</div>
      <label>高强度铝合金+防爆触摸屏设计，防尘、防水、防破坏，耐高温、耐潮湿、耐腐蚀</label>
    </div>
    <pdpp :data="ppdata"></pdpp>
    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdpp from '@/components/pdpp'
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdpp,pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      ppdata: {
        desc: '非接IC读卡器、指纹、磁条IC二合一读卡器、扫码',
        data: [
          {
            pic: require('@/assets/pic/zt595/p1.png'),
            label: '指纹'
          },
          {
            pic: require('@/assets/pic/zt595/p2.png'),
            label: '扫码'
          },
          {
            pic: require('@/assets/pic/zt595/p3.png'),
            label: '磁条IC二合一读卡器'
          },
          // {
          //   pic: require('@/assets/pic/zt595/p4.png'),
          //   label: '非接IC读卡器'
          // }
        ]
      },
      spdata: {
        file: 'ZT595',
        data: [
          {label: _this.$t('lang.cpu'), desc: ['ARM9 400MHz处理器',_this.$t('lang.cpu32bsafe')],pic: 'cpu.png'},
          {label: _this.$t('lang.memory'), desc: ['64MB RAM+128MB ROM','64MB RAM+256MB ROM（可选）',_this.$t('lang.sdexpmax32')],pic: 'ram.png'},
          {label: _this.$t('lang.os'), desc: ['证通安全定制系统','Linux 2.6(ZOS)'], pic: 'sys.png'},
          {label: _this.$t('lang.algor'), desc: [_this.$t('lang.sptalgs')], pic: 'safe.png'},
          {label: _this.$t('lang.display'), desc: ['3.5英寸128×64点阵 LCD'], pic: 'disp.png'},
          {label: _this.$t('lang.cardrdop'), desc: [_this.$t('lang.psicmix1'),_this.$t('lang.tclesscard1'),_this.$t('lang.psamrd2')], pic: 'read.png'},
          {label: _this.$t('lang.mobinet'), desc: ['支持 GSM / WCDMA'], pic: 'mobi.png'},
          {label: _this.$t('lang.wan'), desc: ['10/100Mbps自适应'], pic: 'ethr1.png'},
          {label: _this.$t('lang.keyboard'), desc: ['数字键×12','功能键×4','用户定义按键×4'], pic: 'keyb.png'},
          {label: '蜂鸣器', desc: ['最大音量：85 分贝'], pic: 'speaker.png'},
          {label: _this.$t('lang.volum'), desc: ['标准3.5mm接口'], pic: 'vf.png'},
          {label: _this.$t('lang.protlv'), desc: [_this.$t('lang.ip65ijwt')], pic: 'guard.png'},
          {label: _this.$t('lang.powerinput'), desc: ['DC12V/5A'], pic: 'char.png'},
          {label: _this.$t('lang.port'), desc: ['USB×1、 MicroUSB×1、RS232×4、RJ45×1、电源×1、4G ANT×1、WiFi ANT×1'], pic: 'port.png'},
          {label: _this.$t('lang.size'), desc: ['162mm×141mm×34.3mm'], pic: 'size.png'},
          {label: _this.$t('lang.suitenv'), desc: [_this.$t('lang.wktmp2070'),_this.$t('lang.stortmp4085'),_this.$t('lang.relwet1090')], pic: 'env.png'}
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt595 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt595/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.58rem;
}
#z1 div {
  margin-top: 3.06rem;
  font-size: .6rem;
  font-weight: bold;
  color: #4D4D4D;
}
#z1 label {
  display: block;
  font-size: .4rem;
  font-weight: 400;
  color: #4D4D4D;
  margin-top: .21rem;
}
#z1 img {
  width: 3.5rem;
}
#z2 {
  background: #B4B6B7;
  height: 1.78rem;
  text-align: center;
  overflow: hidden;
}
#z2 label{
  display: block;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin: .45rem auto;
  width: 15.66rem;
  line-height: .48rem;
}
#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt595/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 9.93rem;
}
#z3 div {
  margin: 3.07rem 0 .2rem 0;
  font-size: .6rem;
  font-weight: bold;
  color: #4D4D4D;
}
#z3 label {
  font-size: .24rem;
  font-weight: 400;
  color: #4D4D4D;
  margin-left: .05rem;
  opacity: .7;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt595/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.47rem;
  color: white;
}
#z4 div {
  margin-top: 3.02rem;
  margin-bottom: .18rem;
  font-size: .6rem;
  font-weight: bold;
}
#z4 label {
  font-size: .24rem;
  font-weight: 400;
  color: #FEFEFF;
  width: 6rem;
  display: block;
}

</style>
